// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import siteDataForForm from './siteDataForForm'
import antennaDataForForm from './antennaDataForForm'

import {
  castToString,
  ifEntityGetId,
} from 'helpers/reduxFormFunctions'

// TODO - refactor to not mutate API data
// the culprit is secondSegmentEndAntennaId

const passiveRepeatersForForm = ({ segments }, unitType) => {
  // If there's only one segment, then there are no passive repeaters
  if (segments.length === 1) {
    return []
  }

  const pathLength = segments.length // not GEO path distance/length!

  // returns prepared passive sets for form consumption
  return segments.reduce((a, d, i) => {
    // the last passive set was captured in the second to last loop
    if (i + 1 === pathLength) {
      return a
    }

    // the passive set's raw data
    const p = d.segmentEnds[1]

    // the passive set's antenna. (first antenna if this passive repeater is back-to-back)
    const antenna = p.antennas[0]

    const {
      elevation,
      latitude,
      longitude,
      segmentEndId,
      siteName,
      stateId,
    } = siteDataForForm(p, unitType)

    // since on Site1/Site2 the ASR and Call Sign are in the 'regulatory' section and not the 'site' section,
    // we have to pull them out special here for the Passive Repeater.
    const asr = castToString(p.asr)
    // NOTE - we don't actually NEED call signs on passive repeaters but it's a constraint in Legacy so we need to track
    const callSign = castToString(p.callSign)

    // This value is handled outside of sites[] on the path ends.
    // On passives it's set within the site object
    // On path ends it is set on the regulatory[] objects
    const segmentStatusId = ifEntityGetId(p.segmentStatus)

    // figure out what type of passive repeater this is.
    // if it's a back-to-back, we'll need to add the next
    // segment end's antenna due to how back-to-back repeaters are displayed in UI.
    const isBillboard = antenna.classification === 'Billboard'
    const passiveRepeaterType = (
      isBillboard
        ? 'billboard'
        : 'back-to-back'
    )

    // cleaned passive site's values to minimum from site value set.
    const site = {
      asr,
      callSign,
      elevation,
      elevationUnit: unitType,
      latitude,
      longitude,
      passiveRepeaterType,
      segmentEndId,
      segmentStatusId,
      siteName,
      stateId,
    }

    // aL is an array of antenna objects.
    const aL = []
    // send the first antenna in right away.
    aL.push(antenna)

    // if it's not a billboard, do the back-to-back magic
    if (!isBillboard) {
      const secondAntenna = segments[i + 1].segmentEnds[0].antennas[0]
      aL.push(secondAntenna)
    } else {
      // if it is billboard, we need to capture the second segmentEndAntennaId
      // because once the data's parsed for the UI, these two will only be one
      antenna.secondSegmentEndAntennaId = segments[i + 1].segmentEnds[0].antennas[0].segmentEndAntennaId
    }

    // wether or not its a back-to-back or billboard,
    // we need to persist the secondary segment end id for the second half
    // of the passive repeater
    site.secondSegmentEndId = segments[i + 1].segmentEnds[0].segmentEndId

    // cleaned antenna(s) for this passive set.
    // NOTE - passing { antennas: aL } as an argument
    // because antennaDataForForm assumes it will be parsing
    // a segmentEnd object. That is necessary to assign tilt
    // properly on path end's primary antennas
    const antennas = antennaDataForForm({ antennas: aL }, unitType)

    const backToBack = []
    if (!isBillboard) {
      const commonLoss = castToString(p.commonLoss)
      const polarizationChange = (
        p.polarizationChange === true
          ? 'yes'
          : 'no'
      )
      backToBack.push({
        commonLoss,
        polarizationChange,
      })
    }

    a.push({
      antennas,
      backToBack,
      site,
    })

    return a
  }, [])
}

export default passiveRepeatersForForm
